import { render, staticRenderFns } from "./toolbar-config.vue?vue&type=template&id=6b195fd2&scoped=true&"
import script from "./toolbar-config.vue?vue&type=script&lang=js&"
export * from "./toolbar-config.vue?vue&type=script&lang=js&"
import style0 from "./toolbar-config.vue?vue&type=style&index=0&id=6b195fd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b195fd2",
  null
  
)

export default component.exports